import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import UpdateAppComponent from './js/update-app.component';

ComponentsFactory.getInstance().define('update-app', UpdateAppComponent);
